module.exports = __webpack_public_path__ + "img/transaksi-dijamin-aman.faf299d3.svg";